import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from '@/app/router'
import i18n from '@/app/plugins/i18n'
import pinia from '@/app/plugins/pinia'
import Vue3Lottie from 'vue3-lottie'
import Antd from 'ant-design-vue'

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(Vue3Lottie)
app.use(Antd)

app.mount('#app')
